(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // =========================================================
  // SMART LIVE DEMAND COUNTER & CAROUSEL LOGIC
  // =========================================================
  document.addEventListener('DOMContentLoaded', () => {
    
    // --- 1. Live Demand Logic ---
    const counterEl = document.getElementById('nm-dynamic-order-count');
    const bannerEl = document.querySelector('.nm-live-demand-banner');

    if (counterEl) {
      let currentCount = parseInt(localStorage.getItem('nm_live_sales_count')) || 1439;
      counterEl.innerText = currentCount.toLocaleString();

      setInterval(() => {
        if(Math.random() > 0.4) { 
          const bump = Math.floor(Math.random() * 2) + 1; 
          currentCount += bump;

          counterEl.style.transform = 'scale(1.3)';
          counterEl.style.color = '#112a18';

          setTimeout(() => {
            counterEl.innerText = currentCount.toLocaleString();
            counterEl.style.transform = 'scale(1)';
            counterEl.style.color = '';
          }, 150);

          localStorage.setItem('nm_live_sales_count', currentCount);
        }
      }, Math.floor(Math.random() * 7000) + 8000); 

      const buyButtons = document.querySelectorAll('.nm-buy-now-btn');
      buyButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          currentCount += 1;
          counterEl.innerText = currentCount.toLocaleString();
          localStorage.setItem('nm_live_sales_count', currentCount);

          if (bannerEl) {
            bannerEl.classList.add('nm-pulse-flash');
            setTimeout(() => {
              bannerEl.classList.remove('nm-pulse-flash');
            }, 600);
          }
        });
      });
    }

    // --- 2. Carousel Arrow Logic ---
    const track = document.getElementById('nm-product-track');
    const prevBtn = document.querySelector('.nm-arrow-prev');
    const nextBtn = document.querySelector('.nm-arrow-next');

    if (track && prevBtn && nextBtn) {
      nextBtn.addEventListener('click', () => {
        track.scrollBy({ left: track.offsetWidth, behavior: 'smooth' });
      });

      prevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -track.offsetWidth, behavior: 'smooth' });
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
